module.exports = __webpack_public_path__ + "img/12_52.882bcb91.png";